import React, { FC } from 'react';
import { LogicError } from '../../../shared/error';
import { EventRegistration } from '../../modules/registration/EventRegistration';
import { Fetcher, isLogicError, isResourceError, useFetcher, useUserSafe } from '../../utils';
import { RegistrationClosed } from './RegistrationClosed';

export const NewRegistration: FC = () => {
  const user = useUserSafe();

  const registration = useFetcher(async () => {
    try {
      return await api.getUserActiveRegistration(user.id);
    } catch (error) {
      if (isResourceError(error, 'Registration')) {
        return undefined;
      }

      throw error;
    }
  }, [user.id]);

  if (registration.loading) {
    return <Fetcher result={registration} />;
  }

  if (registration.error && isLogicError(registration.error, LogicError.RegistrationClosed)) {
    return <RegistrationClosed />;
  }

  // If the user already has a registration, then we want to create a sub-account
  return (
    <EventRegistration
      bornAt={registration.data?.id ? null : user.bornAt}
      inputUser={registration.data?.id ? undefined : user}
      targetUserId={registration.data?.id ? undefined : user.id}
    />
  );
};
